import APIConfig from "./APIConfig";
import axiosClient from "../app/axiosConfig";

class AddressService {
  getCoordinatesFromAddress = (addressId) => {
    const url =
      APIConfig.addressService.getCoordinatesFromAddress.format(addressId);
    return axiosClient.get(url);
  };

  updateAddress = (addressId, body) => {
    const url = APIConfig.addressService.updateAddress.format(addressId);
    return axiosClient.put(url, body);
  };

  deleteAddress = (addressId) => {
    const url = APIConfig.addressService.deleteAddress.format(addressId);
    return axiosClient.delete(url);
  };
}

const addressService = new AddressService();
export default addressService;
